import React, { useState, useEffect } from 'react';
import PaymentMethodProvider from './PaymentMethodProvider';
import Text from './Text';
import { useStripe, useElements } from '@stripe/react-stripe-js';
import { useFormikContext } from 'formik';
import { useAppSelector } from '../app/hooks';
import { OrderingSelectors, OrderingConstants, OrderingUtils } from 'polygon-ordering';
import combineStyles from '../utils/combineStyles';
import { CONTAINER_PROPERTIES, TEXT_PROPERTIES } from '../utils/theme';
import getThemeLookup from '../selectors/getThemeLookup';

const { getStripeCurrency, getGatewayType } = OrderingSelectors;
const { PAYMENT_GATEWAY_TYPES, PAYMENT_METHOD } = OrderingConstants;
const { dollarsToCents } = OrderingUtils;

const ApplePayProvider = () => {
  const gatewayType = useAppSelector(getGatewayType);
  const [applePayEnabled, setApplePayEnabled] = useState<boolean | null>(false);
  // eslint-disable-next-line
  const stripe = gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE ? useStripe() : null;
  // eslint-disable-next-line
  const elements = gatewayType === PAYMENT_GATEWAY_TYPES.STRIPE ? useElements() : null;
  const { values } = useFormikContext<FormikFields>();
  const stripeCurrency = useAppSelector(getStripeCurrency);
  const p = useAppSelector(getThemeLookup);

  useEffect(() => {
    if (gatewayType !== PAYMENT_GATEWAY_TYPES.STRIPE || !stripe || !elements) {
      return;
    }
    // From what I can tell, this payment request is only used to check if apple pay is enabled
    // PLEASE DO NOT TRY TO MAKE A PAYMENT USING THIS PAYMENT REQUEST AS YOU WILL PROBABLY DOUBLE CHARGE THE USER
    // In my opinion all of the payments code should be refactored so that this isn't confusing
    const pr = stripe.paymentRequest({
      country: 'AU', // TODO: fix to avoid stripe overseas fees
      currency: stripeCurrency,
      total: {
        label: 'Payment Total:',
        amount: dollarsToCents(values.Amount!) + Number(values.surcharge) || 0,
      },
    });

    pr.canMakePayment().then(result => {
      if (result?.applePay) {
        setApplePayEnabled(true);
      }
    });
  }, [stripe, elements, gatewayType]);

  useEffect(() => {
    if (
      gatewayType === PAYMENT_GATEWAY_TYPES.TYRO &&
      (window as Window & typeof globalThis & { ApplePaySession: any })?.ApplePaySession
    ) {
      setApplePayEnabled(true);
    }
  }, []);

  return (
    <>
      {applePayEnabled && (
        <PaymentMethodProvider
          method={PAYMENT_METHOD.APPLE_PAY}
          right={
            <div style={styles.buttonContainer}>
              <div style={styles.markContainer}>
                <img
                  src="https://assets.redcatcloud.com.au/webordering/Apple_Pay_Mark_RGB_041619.svg"
                  style={combineStyles(
                    { height: 30 },
                    p('applePayLogo', [...TEXT_PROPERTIES, ...CONTAINER_PROPERTIES]),
                  )}
                />
              </div>
            </div>
          }
          subtitle={<Text themeKey="paymentMethodUnavailableReason">&nbsp;</Text>}
        />
      )}
    </>
  );
};

const styles: Styles = {
  buttonContainer: {
    position: 'relative',
  },
  markContainer: {
    position: 'relative',
    // top: -26,
    // left: 'auto',
    right: 4,
  },
};

export default ApplePayProvider;
